// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__15cHq","content":"LoadingAlert_content__2aKIl"};